module.exports = "/images/error-page-pattern.png?fa336e7652e01ad93bf6b8936fdee5b8";